module.exports = __webpack_public_path__ + "static/room04-550dee436cb3a62fb69681d2747ed18e.jpg";